import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { SalesByItemReportTableAccessor } from '../../enums/salesByItemReportTableAccessor'
import { SalesByValueReportTableRow } from '../../types/salesByValueReportTableRow'
import { useSalesByItemReport } from './useSalesByItemReport'

export const useSalesByItemReportTableData = (): SalesByValueReportTableRow[] => {
  const { salesByItemReport } = useSalesByItemReport()

  return useMemo(
    () =>
      salesByItemReport.map(({ productName, summary }) => {
        return {
          [SalesByItemReportTableAccessor.GrossTotal]: summary.all.grossTotal,
          [SalesByItemReportTableAccessor.ItemName]: productName,
          [SalesByItemReportTableAccessor.ItemQuantity]: summary.all.quantity,
          [SalesByItemReportTableAccessor.ItemType]: summary.all.productType,
          [SalesByItemReportTableAccessor.NetTotal]: summary.all.netTotal,
          id: uuidv4(),
        }
      }),
    [salesByItemReport],
  )
}
